export const validateId = (id: string | number | null | undefined): boolean => {
  if (typeof id === "number") {
    id = String(id);
  }
  return typeof id === "string" && /^\d+$/.test(id);
};
